// 需要 jquery
if (!customElements.get("scroll-featured-collection")) {
  customElements.define(
    "scroll-featured-collection",
    class ScrollFeaturedCollection extends HTMLElement {
      constructor() {
        super();
        this.sectionId = $(this).attr("data-sectionId");
        this.desktopShowNum = $(this).attr("data-desktopShowNum");
        this.mobileShowNum = $(this).attr("data-mobileShowNum");
        this.rowGap = $(this).attr("data-rowGap");
        this.sfcSwiper = $(this).find(`.swiper-${this.sectionId}`);
        this.initScrollFeaturedCollection();
      }

      initScrollFeaturedCollection() {
        const that = this;

        setTimeout(function () {
          let windowWidth = $(window).width();
          let rowGap = Number(that.rowGap);
          let mobileShowNum = Number(that.mobileShowNum);
          let desktopShowNum = Number(that.desktopShowNum);
          console.log(`.swiper-${that.sectionId}-view`, "-------");
          new Swiper(`.swiper-${that.sectionId}-view`, {
            navigation: {
              nextEl: `.swiper-${that.sectionId}-view .swiper-button-next`,
              prevEl: `.swiper-${that.sectionId}-view .swiper-button-prev`,
            },
            breakpoints: { 
              320: {  //当屏幕宽度大于等于320
                slidesPerView: mobileShowNum,
                spaceBetween: 10,
                slidesPerGroup:mobileShowNum
              },
              768: {  //当屏幕宽度大于等于768 
                slidesPerView: mobileShowNum,
                spaceBetween: 20,
                slidesPerGroup:mobileShowNum
              },
              1280: {  //当屏幕宽度大于等于1280
                slidesPerView: desktopShowNum,
                spaceBetween: 30,
                slidesPerGroup:1
              }
            }
          });
          // that.sfcSwiper.slick({
          //   slidesToShow: desktopShowNum,
          //   slidesToScroll: 1,
          //   autoplay: false,
          //   arrows: true,
          //   rows:0,
          //   adaptiveHeight:false,
          //   responsive:[
          //     {
          //       breakpoint: 768,
          //       settings: {
          //         autoplay: false,
          //         slidesToShow: mobileShowNum,
          //         slidesToScroll: mobileShowNum
          //       }
          //     }
          //   ]
          // });
        }, 0);
      }
    }
  );
}
